import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import alb from 'services/api/alb';

export const verifyIsSlow = async (cycleId: number): Promise<boolean> => {
	const url = `restricted-plan/recalculate/verify-is-slow`;
	const response: AxiosResponse<{ is_slow: boolean }> = await alb.post(url, {
		cycle_id: cycleId,
	});
	return response.data.is_slow;
};

export const useVerifyIsSlow = ({ cycleId }: { cycleId: number }) => {
	return useQuery({
		queryKey: ['verify-is-slow', cycleId],
		queryFn: () => verifyIsSlow(cycleId),
		enabled: !!cycleId,
		refetchOnWindowFocus: false,
	});
};
